import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "修改历史", -1)
const _hoisted_2 = { class: "change_dialog_container" }
const _hoisted_3 = { class: "we-table-cell" }
const _hoisted_4 = { class: "we-table-span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_we_table = _resolveComponent("we-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
    maskClosable: "",
    width: "1000px",
    closable: false,
    centered: "",
    footer: null,
    afterClose: _ctx.closeDialog
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_we_table, {
          dataSource: _ctx.changeList,
          columns: _ctx.columns,
          useSearchForm: false,
          tabConfig: null,
          loading: _ctx.loadingChangeList,
          pagination: false,
          showTableHeader: false
        }, {
          changer: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userMap[record.owner_id] ? _ctx.userMap[record.owner_id].name : '' + record.owner_id) + " (" + _toDisplayString(record.owner_id) + ") ", 1)
            ])
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "afterClose"]))
}